const MaxDeltaTime = 1;
/**
 * フレームアップデートをするクラス
 */
class Ticker {
    _events;
    _requestId = 0;
    _lastUpdateTime = 0;
    _updateFunction;
    constructor() {
        this._events = [];
        this._updateFunction = this._update.bind(this);
    }
    add(object, fn) {
        let _obj = object;
        let _fn = fn;
        if (!_fn) {
            if (!(_obj instanceof Function)) {
                throw new Error('Ticker.add requires Function or Object and Function');
            }
            _fn = _obj;
            _obj = null;
        }
        this._events.push({
            target: _obj,
            fn: _fn
        });
        if (this._events.length === 1) {
            this._lastUpdateTime = Date.now();
        }
        this._requestUpdate();
    }
    remove(object, fn) {
        let _obj = object;
        let _fn = fn;
        if (!_fn) {
            if (!(_obj instanceof Function)) {
                throw new Error('Ticker.remove requires Function or Object and Function');
            }
            _fn = _obj;
            _obj = null;
        }
        for (let i = 0; i < this._events.length; i++) {
            const event = this._events[i];
            if ((event.target === _obj && event.fn === _fn) || (!_obj && event.fn === _fn)) {
                this._events.splice(i, 1);
                i--;
            }
        }
    }
    _requestUpdate() {
        if (this._requestId === 0) {
            this._requestId = window.requestAnimationFrame(this._updateFunction);
        }
    }
    _update() {
        const currentTime = Date.now();
        let dt = (currentTime - this._lastUpdateTime) / 1000;
        this._lastUpdateTime = currentTime;
        this._requestId = 0;
        // Note: ページがバックグラウンドに行った時などに、dtが大きな数にならないようにする
        if (dt > MaxDeltaTime) {
            dt = MaxDeltaTime;
        }
        if (dt === 0) {
            dt = Number.EPSILON || 2.2204460492503130808472633361816E-16;
        }
        for (let i = 0; i < this._events.length; i++) {
            const event = this._events[i];
            if (event.target) {
                event.fn.call(event.target, dt);
            }
            else {
                event.fn(dt);
            }
        }
        if (this._events.length > 0) {
            this._requestUpdate();
        }
    }
}
export default new Ticker();
//# sourceMappingURL=Ticker.js.map